module.exports = __webpack_public_path__ + "static/media/Slice6.fa0c67a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_151/img/Slice6.png
// module id = 1487
// module chunks = 0